import { render, staticRenderFns } from "./FamilyProductAttribute.vue?vue&type=template&id=009215ae&scoped=true"
import script from "./FamilyProductAttribute.vue?vue&type=script&lang=js"
export * from "./FamilyProductAttribute.vue?vue&type=script&lang=js"
import style0 from "./FamilyProductAttribute.vue?vue&type=style&index=0&id=009215ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009215ae",
  null
  
)

export default component.exports